import Vue from 'vue';
const initialSnackbarState = () => ({
  show: false,
  title: '',
  content: '',
  snackbarErrorText: '',
  snackbarCloseBtn: false,
  showModal: false
});

const state = {
  snackbars: {} // uploadId: { snackbar: {}, hideBtn: false }
};

const mutations = {
  INIT_SNACKBAR(state, { uploadId }) {
    console.log('INIT_SNACKBAR', uploadId);
    if (!state.snackbars?.uploadId) {
      state.snackbars[uploadId] = {
        snackbar: initialSnackbarState(),
        hideBtn: false
      };
    }
  },
  SHOW_SNACKBAR(state, { uploadId }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'show', true);
  },
  SHOW_SNACKMODAL(state, { uploadId }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'showModal', true);
  },
  CLOSE_SNACKBAR_CLOSEBTN(state, { uploadId }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'snackbarCloseBtn', true);
  },
  CLOSE_SNACKBAR(state, { uploadId }) {
    if (state.snackbars[uploadId] && state.snackbars[uploadId].snackbar) {
      Object.assign(state.snackbars[uploadId].snackbar, initialSnackbarState());
    }
  },
  SET_SNACKBAR_ERROR(state, { uploadId, errorText }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'snackbarErrorText', errorText);
  },
  SHOW_CLOSE_BUTTON(state, { uploadId }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'snackbarCloseBtn', true);
  },
  SHOW_MODAL(state, { uploadId, content }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'showModal', true);
    Vue.set(state.snackbars[uploadId].snackbar, 'content', content);
  },
  HIDE_MODAL(state, { uploadId }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'showModal', false);
    Vue.set(state.snackbars[uploadId].snackbar, 'content', '');
  },
  RESET_SNACKBAR(state, { uploadId }) {
    Object.assign(state.snackbars[uploadId].snackbar, initialSnackbarState());
  },
  SET_SNACKBAR_CONTENT(state, { uploadId, content }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'content', content);
  },
  SET_SNACKBAR_TITLE(state, { uploadId, title }) {
    Vue.set(state.snackbars[uploadId].snackbar, 'title', title);
  }
  // HIDE_SNACKBAR(state, { uploadId }) {
  // 	Vue.set(state.snackbars[uploadId].snackbar, 'show', false);
  // }
};

const actions = {
  initSnackbar({ commit }, uploadId) {
    commit('INIT_SNACKBAR', { uploadId });
  },
  triggerSnackbar({ commit }, uploadId) {
    if(!state.snackbars[uploadId]){
      commit('INIT_SNACKBAR', { uploadId });
    }
    commit('SHOW_SNACKBAR', { uploadId });
  },
  closeSnackbar({ commit }, uploadId) {
    if(!state.snackbars[uploadId]){
      commit('INIT_SNACKBAR', { uploadId });
    }
    commit('CLOSE_SNACKBAR', { uploadId });
  },
  setSnackbarTitle({ commit }, { uploadId, title }) {
    commit('SET_SNACKBAR_TITLE', { uploadId, title });
  },
  setSnackbarContent({ commit }, { uploadId, content }) {
    commit('SET_SNACKBAR_CONTENT', { uploadId, content });
  },
  setSnackbarError({ commit }, { uploadId, errorText }) {
    commit('SET_SNACKBAR_ERROR', { uploadId, errorText });
  },
  showCloseButton({ commit }, uploadId) {
    commit('SHOW_CLOSE_BUTTON', { uploadId });
  },
  showModal({ commit }, { uploadId, content }) {
    commit('SHOW_MODAL', { uploadId, content });
  },
  hideModal({ commit }, uploadId) {
    commit('HIDE_MODAL', { uploadId });
  },
  resetSnackbar({ commit }, uploadId) {
    commit('RESET_SNACKBAR', { uploadId });
  },
  closeSnackbarCloseBtn({ commit }, uploadId) {
    commit('CLOSE_SNACKBAR_CLOSEBTN', { uploadId });
  }
  // hideSnackbar({ commit }, uploadId) {
  //   commit("HIDE_SNACKBAR", { uploadId });
  // }
};

const getters = {
  snackbar: (state) => (uploadId) => state.snackbars[uploadId] ? state.snackbars[uploadId].snackbar : {},
  hideBtn: (state) => (uploadId) => state.snackbars[uploadId] ? state.snackbars[uploadId].hideBtn : false,
  snackbars: (state) => state.snackbars
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
